module.exports = __webpack_public_path__ + "img/1.a70074a0.png";